<div class="p-modal-payment-detail">
  <div class="p-modal-payment-detail__detail">
    <div class="p-modal-payment-detail__detail-block">
      <div class="p-modal-payment-detail__detail-row">
        <dl class="c-float-list04">
          <div class="c-float-list04__item">
            <dt class="c-float-list04__title">
              <span class="c-float-list04__title-total" [innerHTML]="'label.totalAmount' | staticMsg"></span>
            </dt>
            <dd class="c-float-list04__contents">
              <div class="c-float-list04__contents-item c-float-list04__contents-item--em">
                <span class="c-amount c-amount--price">
                  <span class="c-amount__num c-amount__num--fs24" [innerHTML]="totalAmount | amountFormat"></span>
                </span>
              </div>
              <div class="c-float-list04__contents-item" [innerHTML]="passengerNumberDisplayText"></div>
              <div
                *ngIf="isMexico"
                class="c-float-list04__contents-item c-float-list04__contents-item--fs10 c-float-list04__contents-item--gray60"
                [innerHTML]="'message.ancillaryServiceChargesIncludeTax' | staticMsg"
              ></div>
            </dd>
          </div>
        </dl>
      </div>
    </div>
  </div>
</div>
